import {Pipe, PipeTransform} from '@angular/core';
import {Booking} from "../models/booking";

@Pipe({
    name: 'potentialDriverStatuses'
})
export class PotentialDriverStatusesPipe implements PipeTransform {

    transform(driverId: string, booking: Booking): unknown {
        console.log(driverId, booking);
        let actions = [];
        booking.updates.forEach(update => {
            if(update.action === 'systemSearchDrivers' && (actions.length === 0 || actions[actions.length - 1] !== 'Pending')) {
                actions.push('Pending');
            }
            if(update.user && update.user.toString() === driverId.toString()) {
                switch (update.action) {
                    case 'driverAcceptIntend':
                        actions.push('Accept Intend');
                        break;
                    case 'driverAccepted':
                        actions.push('Accept');
                        break;
                    case 'driverDeclined':
                        actions.push('Decline');
                        break;
                }
            }
        })
        return actions.join(', ');
    }

}
